import Modal from "@mui/material/Modal";
import {kButtonStyles, kModalStyles} from "../../constants/styles";
import SystemDialogClosingCrossIcon from "../icons/SystemDialogClosingCrossIcon";
import SystemModalTexts from "../texts/SystemModalTexts";
import {SystemPrimaryCustomButton, SystemSecondaryCustomButton} from "../buttons/SystemCustomButton";
import SystemDialogHeaderLayout from "../layouts/SystemDialogHeaderLayout";
import SystemDialogMainImage from "../images/SystemDialogMainImage";
import {kFlashTexts, kSystemTexts} from "../../constants/texts";
import {kSystemImages} from "../../constants/images";

export default function SystemLeaveFlashDialog({ open,
                                                 handleClose,
                                                 leave }) {
    // Used in MetaFlashScreen to ask confirmation
    // about leaving current flash

    // BUILD
    return(
        <Modal open={open}
               onClose={handleClose}>
            <div className={kModalStyles.dialogStyle}>
                <SystemDialogHeaderLayout>
                    <SystemDialogClosingCrossIcon onIconPress={() => handleClose()}/>
                    <SystemDialogMainImage imageUrl={kSystemImages.cryingFox}
                                           alt="Renard triste" />
                </SystemDialogHeaderLayout>
                <SystemModalTexts title={kFlashTexts.leaveCurrentFlashTitle}
                                  subtitle={kFlashTexts.leaveCurrentFlashSubtitle} />
                <div className="w-full flex space-x-16">
                    <SystemSecondaryCustomButton
                        label={kSystemTexts.cancel}
                        isDisabled={false}
                        isLoading={false}
                        isFullWidth={true}
                        sizeStyle={kButtonStyles.mediumButtonStyle}
                        onButtonClick={() => handleClose()}
                        extraClass={"w-full"}/>
                    <SystemPrimaryCustomButton
                        label={kSystemTexts.leave}
                        isDisabled={false}
                        isLoading={false}
                        isFullWidth={true}
                        onButtonClick={leave}
                        sizeStyle={kButtonStyles.mediumButtonStyle}/>
                </div>
            </div>
        </Modal>
    )
}